/* eslint-disable camelcase */
import { ErrorAlert } from "common/ui-components";
import { EnsureTenant } from "core/auth/EnsureTenant";
import { config } from "core/config";
import { FunctionComponent, PropsWithChildren, useMemo } from "react";

import { CenteredLargeSpinner } from "@bps/fluent-ui";
import {
  CloudApplications,
  AuthenticationProvider as MsalAuthenticationProvider,
  MsalConfig,
  useMsalPolicy,
  WithResumeSessionsProps
} from "@bps/msal";

const redirectUri = `${window.location.origin}/`;

export const AuthenticationProvider: FunctionComponent<
  PropsWithChildren
> = props => {
  const { authority, extraQueryParameters } = useMsalPolicy(
    window.location.search,
    config.msal.authority ?? ""
  );

  const { skip_resume_screen, ...restExtraQueryParameters } =
    extraQueryParameters;

  const withResumeSessionsProps = useMemo(():
    | WithResumeSessionsProps
    | undefined => {
    if (!!skip_resume_screen) {
      return undefined;
    }

    return {
      storeSessionsKey: config.appKey,
      bpIdApiBaseUrl: config.bpIdApiBaseUrl,
      appCode: CloudApplications.Premiere
    };
  }, [skip_resume_screen]);

  return (
    <MsalAuthenticationProvider
      config={{
        ...config.msal,
        authority,
        redirectUri,
        extraQueryParameters:
          restExtraQueryParameters as unknown as MsalConfig["extraQueryParameters"],
        loginHint: restExtraQueryParameters.login_hint,
        prompt: restExtraQueryParameters.prompt,
        // ⚠️ The redirectStartPage and navigateToLoginRequestUrl parameters allow users to be redirected to the last viewed page after logging in. Ilya S.
        redirectStartPage: window.location.href,
        postAuthenticateRedirectUrl: window.location.href,
        navigateToLoginRequestUrl: true
      }}
      renderSpinner={message => (
        <CenteredLargeSpinner label={message} labelPosition="bottom" />
      )}
      renderError={message => <ErrorAlert error={message} />}
      withResumeSessionsProps={withResumeSessionsProps}
      {...props}
    >
      <EnsureTenant>{props.children}</EnsureTenant>
    </MsalAuthenticationProvider>
  );
};
